import {
  accountsRoute, ALL_MODEL_LABEL,
  allModelLabelData, billingCategoriesRoute, billingRoute, coinTypesRoute,
  consolidateRoutes,
  CreateRoute, customerCarriersRoute,
  customersRoute, incidentReportModelRoute, incidentReportRoute, InventoryRoute, inventoryTransferRoute, ledgerRoute, MAIN_LABEL, organizationsRoute,
  permissionsRoute, ProcessingRoute, productionLineRoute, productionRoute, productsRoute,
  reportingRoute,
  rolesRoute, SatelliteCompletedOrdersRoute, SatelliteOrderInRoute, SatelliteOrderOutRoute, SatellitePendingReleaseRoute, SatelliteWrapRoute, sortingRoute, StatusRoute, unitTypeRoute,
  vaultRoute,
  waitingOnReportRoute
} from "../../../../../app/modules/coinWrap/Helpers/Common/CommonComponent";
import VerifiedIcon from '@mui/icons-material/Verified';

const dashboardItem = {
  label: "Dashboard",
  FWIconClassName: "fas fa-layer-group",
  linkTo: "/dashboard",
  checkIfLicenseExist: true,
  licenseCheckField: null,
  sectionLabel: "NO_LABEL",
  permissionType: MAIN_LABEL.DASHBOARD,
};

const MintItems = [
  {
    sectionLabel: "NO_LABEL",
    FWIconClassName: "fas fa-dolly",
    linkTo: "/transport-orders",
    checkIfLicenseExist: true,
    licenseCheckField: null,
    label: "Transport Orders",
    permissionType: MAIN_LABEL.TRANSPORT_ORDERS,
  },
  {
    sectionLabel: "NO_LABEL",
    FWIconClassName: "far fa-copy",
    linkTo: "/models",
    checkIfLicenseExist: true,
    licenseCheckField: null,
    label: "Models",
    permissionType: ALL_MODEL_LABEL.MODELS,
    items: [
      {
        FWIconClassName: "far fa-circle",
        linkTo: "/models/locations",
        checkIfLicenseExist: true,
        licenseCheckField: null,
        label: "Locations",
        permissionType: MAIN_LABEL.LOCATIONS,
      },
      {
        FWIconClassName: "far fa-circle",
        linkTo: coinTypesRoute,
        checkIfLicenseExist: true,
        licenseCheckField: null,
        label: "Product Types",
        permissionType: MAIN_LABEL.PRODUCT_TYPES,
      },
      {
        FWIconClassName: "far fa-circle",
        linkTo: productsRoute,
        checkIfLicenseExist: true,
        licenseCheckField: null,
        label: "Products",
        permissionType: MAIN_LABEL.PRODUCTS
      },
      {
        FWIconClassName: "far fa-circle",
        linkTo: "/models/coinTypeProducts",
        checkIfLicenseExist: true,
        licenseCheckField: null,
        label: "Coin Type Products",
        permissionType: MAIN_LABEL.COIN_TYPE_PRODUCTS,
      },
      {
        FWIconClassName: "far fa-circle",
        linkTo: "/models/carrier",
        checkIfLicenseExist: true,
        licenseCheckField: null,
        label: "Carriers",
        permissionType: MAIN_LABEL.CARRIERS,
      },
      {
        FWIconClassName: "far fa-circle",
        linkTo: unitTypeRoute,
        checkIfLicenseExist: true,
        licenseCheckField: null,
        label: "Product Unit Types",
        permissionType: MAIN_LABEL.PRODUCT_UNIT_TYPES,
      },
      {
        FWIconClassName: "far fa-circle",
        linkTo: "/models/users",
        checkIfLicenseExist: true,
        licenseCheckField: null,
        label: "Users",
        permissionType: MAIN_LABEL.USERS,
      },
      {
        FWIconClassName: "far fa-circle",
        linkTo: customersRoute,
        checkIfLicenseExist: true,
        licenseCheckField: null,
        label: "Customers",
        permissionType: MAIN_LABEL.CUSTOMERS,
      },
      {
        FWIconClassName: "far fa-circle",
        linkTo: customerCarriersRoute,
        checkIfLicenseExist: true,
        licenseCheckField: null,
        label: "Customer Carriers",
        permissionType: MAIN_LABEL.CUSTOMER_CARRIERS,
      },
      {
        FWIconClassName: "far fa-circle",
        linkTo: productionLineRoute,
        checkIfLicenseExist: true,
        licenseCheckField: null,
        label: "Production Line",
        permissionType: MAIN_LABEL.PRODUCTION_LINE,
      },
      {
        sectionLabel: "NO_LABEL",
        FWIconClassName: "",
        menuIcon: VerifiedIcon,
        linkTo: "/models",
        checkIfLicenseExist: true,
        licenseCheckField: null,
        label: "Verification Models",
        permissionType: ALL_MODEL_LABEL.VERIFICATION,
        items: [
          {
            FWIconClassName: "far fa-circle",
            linkTo: billingCategoriesRoute,
            checkIfLicenseExist: true,
            licenseCheckField: null,
            label: "Billing Categories",
            permissionType: MAIN_LABEL.BILLING_CATEGORIES,
          },
          {
            FWIconClassName: "far fa-circle",
            linkTo: billingRoute,
            checkIfLicenseExist: true,
            licenseCheckField: null,
            label: "Billing",
            permissionType: MAIN_LABEL.BILLING,
          }
        ],
      },
      {
        sectionLabel: "NO_LABEL",
        FWIconClassName: "fas fa-users",
        linkTo: "/models",
        checkIfLicenseExist: true,
        licenseCheckField: null,
        label: "Employees",
        permissionType: ALL_MODEL_LABEL.EMPLOYEES,
        items: [
          {
            FWIconClassName: "far fa-circle",
            linkTo: "/models/employees",
            checkIfLicenseExist: true,
            licenseCheckField: null,
            label: "Employees",
            permissionType: MAIN_LABEL.EMPLOYEES,
          },
          {
            FWIconClassName: "far fa-circle",
            linkTo: "/models/regions",
            checkIfLicenseExist: true,
            licenseCheckField: null,
            label: "Regions",
            permissionType: MAIN_LABEL.REGIONS,
          },
          {
            FWIconClassName: "far fa-circle",
            linkTo: "/models/divisions",
            checkIfLicenseExist: true,
            licenseCheckField: null,
            label: "Divisions",
            permissionType: MAIN_LABEL.DIVISIONS,
          },
        ],
      },
      {
        sectionLabel: "NO_LABEL",
        FWIconClassName: "fas fa-building",
        linkTo: "/models",
        checkIfLicenseExist: true,
        licenseCheckField: null,
        label: "Inventory Models",
        permissionType: ALL_MODEL_LABEL.INVENTORY,
        items: [
          {
            FWIconClassName: "far fa-circle",
            linkTo: organizationsRoute,
            checkIfLicenseExist: true,
            licenseCheckField: null,
            label: "Organizations",
            permissionType: MAIN_LABEL.ORGANIZATIONS,
          },
          {
            FWIconClassName: "far fa-circle",
            linkTo: accountsRoute,
            checkIfLicenseExist: true,
            licenseCheckField: null,
            label: "Accounts",
            permissionType: MAIN_LABEL.ACCOUNTS,
          },
        ],
      },
    ],
  },
  {
    sectionLabel: "NO_LABEL",
    FWIconClassName: "fas fa-warehouse",
    linkTo: InventoryRoute,
    checkIfLicenseExist: true,
    licenseCheckField: null,
    label: "Inventory",
    permissionType: MAIN_LABEL.INVENTORY,
  },
  {
    sectionLabel: "NO_LABEL",
    FWIconClassName: "fas fa-exchange-alt",
    linkTo: inventoryTransferRoute,
    checkIfLicenseExist: true,
    licenseCheckField: null,
    label: "Inventory Transfer",
    permissionType: MAIN_LABEL.INVENTORY_TRANSFER,
  },
  {
    sectionLabel: "NO_LABEL",
    FWIconClassName: "fas fa-wallet",
    linkTo: ledgerRoute,
    checkIfLicenseExist: true,
    licenseCheckField: null,
    label: "Ledger",
    permissionType: MAIN_LABEL.INVENTORY,
  },
  {
    sectionLabel: "NO_LABEL",
    FWIconClassName: "fas fa-shipping-fast",
    linkTo: "/orders",
    checkIfLicenseExist: true,
    licenseCheckField: null,
    label: "Orders",
    permissionType: ALL_MODEL_LABEL.ORDERS,
    items: [
      {
        FWIconClassName: "far fa-circle",
        linkTo: CreateRoute,
        checkIfLicenseExist: true,
        licenseCheckField: null,
        label: "Create",
        permissionType: MAIN_LABEL.CREATE
      },
      {
        FWIconClassName: "far fa-circle",
        linkTo: StatusRoute,
        checkIfLicenseExist: true,
        licenseCheckField: null,
        label: "Status",
        permissionType: MAIN_LABEL.STATUS
      },
      {
        FWIconClassName: "far fa-circle",
        linkTo: ProcessingRoute,
        checkIfLicenseExist: true,
        licenseCheckField: null,
        label: "Processing",
        permissionType: MAIN_LABEL.PROCESSING,
      },
    ],
  },
  {
    sectionLabel: "NO_LABEL",
    FWIconClassName: "fas fa-satellite",
    linkTo: "/satellite",
    checkIfLicenseExist: true,
    licenseCheckField: null,
    label: "Satellite",
    permissionType: ALL_MODEL_LABEL.SATELLITE,
    items: [
      {
        FWIconClassName: "far fa-circle",
        linkTo: SatelliteOrderInRoute,
        checkIfLicenseExist: true,
        licenseCheckField: null,
        label: "Order In",
        permissionType: MAIN_LABEL.SATELLITEORDERIN
      },
      {
        FWIconClassName: "far fa-circle",
        linkTo: SatelliteWrapRoute,
        checkIfLicenseExist: true,
        licenseCheckField: null,
        label: "Wrap Order",
        permissionType: MAIN_LABEL.SATELLITEWRAPORDER
      },
      {
        FWIconClassName: "far fa-circle",
        linkTo: SatellitePendingReleaseRoute,
        checkIfLicenseExist: true,
        licenseCheckField: null,
        label: "Pending Release",
        permissionType: MAIN_LABEL.SATELLITEPENDINGRELEASE
      },
      {
        FWIconClassName: "far fa-circle",
        linkTo: SatelliteOrderOutRoute,
        checkIfLicenseExist: true,
        licenseCheckField: null,
        label: "Order OUT",
        permissionType: MAIN_LABEL.SATELLITEORDEROUT
      },
      {
        FWIconClassName: "far fa-circle",
        linkTo: SatelliteCompletedOrdersRoute,
        checkIfLicenseExist: true,
        licenseCheckField: null,
        label: "Completed Orders",
        permissionType: MAIN_LABEL.SATELLITECOMPLTEDORDERS
      },
      {
        FWIconClassName: "far fa-circle",
        linkTo: waitingOnReportRoute,
        checkIfLicenseExist: true,
        licenseCheckField: null,
        label: "Waiting On Report",
        permissionType: MAIN_LABEL.WAITING_ON_REPORT,
      },
      {
        FWIconClassName: "far fa-circle",
        linkTo: incidentReportModelRoute,
        checkIfLicenseExist: true,
        licenseCheckField: null,
        label: "Incident Report Model",
        permissionType: MAIN_LABEL.INCIDENT_REPORT_MODEL,
      },
      {
        FWIconClassName: "far fa-circle",
        linkTo: incidentReportRoute,
        checkIfLicenseExist: true,
        licenseCheckField: null,
        label: "Incident Report",
        permissionType: MAIN_LABEL.INCIDENT_REPORT,
      },
    ],
  },
  {
    sectionLabel: "NO_LABEL",
    FWIconClassName: "fas fa-industry",
    linkTo: productionRoute,
    checkIfLicenseExist: true,
    licenseCheckField: null,
    label: "Production",
    permissionType: MAIN_LABEL.PRODUCTION,
  },
  {
    sectionLabel: "NO_LABEL",
    FWIconClassName: "fas fa-door-closed",
    linkTo: vaultRoute,
    checkIfLicenseExist: true,
    licenseCheckField: null,
    label: "Vault",
    permissionType: MAIN_LABEL.VAULT,
  },
  {
    sectionLabel: "NO_LABEL",
    FWIconClassName: "fas fa-funnel-dollar",
    linkTo: sortingRoute,
    checkIfLicenseExist: true,
    licenseCheckField: null,
    label: "Sorting",
    permissionType: MAIN_LABEL.SORTING,
  },
  {
    sectionLabel: "NO_LABEL",
    FWIconClassName: "fas fa-tasks",
    linkTo: consolidateRoutes,
    checkIfLicenseExist: true,
    licenseCheckField: null,
    label: allModelLabelData["Consolidate Control ID"],
    permissionType: MAIN_LABEL.CONTROL_ID_MGMT,
    // items: [
    // {
    //   FWIconClassName: "far fa-circle",
    //   linkTo: conversionStatusRoutes,
    //   checkIfLicenseExist: true,
    //   licenseCheckField: null,
    //   label: "Status",
    //   permissionType: MAIN_LABEL.STATUS
    // },
    // {
    //   FWIconClassName: "far fa-circle",
    //   linkTo: conversionProductionRoutes,
    //   checkIfLicenseExist: true,
    //   licenseCheckField: null,
    //   label: "Production",
    //   permissionType: MAIN_LABEL.STATUS
    // },
    // {
    //   FWIconClassName: "far fa-circle",
    //   linkTo: consolidateRoutes,
    //   checkIfLicenseExist: true,
    //   licenseCheckField: null,
    //   label: "Consolidate",
    //   permissionType: MAIN_LABEL.STATUS,
    // },
    // ],
  },
  {
    sectionLabel: "NO_LABEL",
    FWIconClassName: "fas fa-clipboard-list",
    linkTo: "/shipment-files",
    checkIfLicenseExist: true,
    licenseCheckField: null,
    label: "Shipment Files",
    permissionType: MAIN_LABEL.SHIPMENT_FILES,
  },
  {
    sectionLabel: "NO_LABEL",
    FWIconClassName: "fas fa-file",
    linkTo: "/documents",
    checkIfLicenseExist: true,
    licenseCheckField: null,
    label: "Documents",
    permissionType: MAIN_LABEL.DOCUMNETS,
  },
  {
    sectionLabel: "NO_LABEL",
    FWIconClassName: "fas fa-user-cog",
    linkTo: "/roles-permissions",
    checkIfLicenseExist: true,
    licenseCheckField: null,
    label: "Roles and Permissions",
    permissionType: ALL_MODEL_LABEL.ROLES_AND_PERMISSIONS,
    items: [
      {
        FWIconClassName: "far fa-circle",
        linkTo: permissionsRoute,
        checkIfLicenseExist: true,
        licenseCheckField: null,
        label: "Permissions",
        permissionType: MAIN_LABEL.PERMISSIONS,
      },
      {
        FWIconClassName: "far fa-circle",
        linkTo: rolesRoute,
        checkIfLicenseExist: true,
        licenseCheckField: null,
        label: "Roles",
        permissionType: MAIN_LABEL.ROLES,
      },
    ],
  },
  {
    sectionLabel: "NO_LABEL",
    FWIconClassName: "fas fa-cog",
    linkTo: "/settings",
    checkIfLicenseExist: true,
    licenseCheckField: null,
    label: "Settings",
    permissionType: MAIN_LABEL.SETTINGS,
  },
  {
    sectionLabel: "NO_LABEL",
    FWIconClassName: "fas fa-clipboard-check",
    linkTo: "/audit-logs",
    checkIfLicenseExist: true,
    licenseCheckField: null,
    label: "Audit Logs",
    permissionType: MAIN_LABEL.AUDIT_LOGS,
  },
  {
    sectionLabel: "NO_LABEL",
    FWIconClassName: "fas fa-clipboard-list",
    linkTo: "/control-id-history",
    checkIfLicenseExist: true,
    licenseCheckField: null,
    label: allModelLabelData["Control ID Actions"],
    permissionType: MAIN_LABEL.CONTROL_ID_HISTORY,
  },
  {
    sectionLabel: "NO_LABEL",
    FWIconClassName: "fas fa-file-excel",
    linkTo: reportingRoute,
    checkIfLicenseExist: true,
    licenseCheckField: null,
    label: "Reporting",
    permissionType: MAIN_LABEL.REPORTING,
  },
  {
    sectionLabel: "NO_LABEL",
    FWIconClassName: "fas fa-external-link-alt",
    linkTo: process.env.REACT_APP_OFFSHORT_URL || "#",
    checkIfLicenseExist: true,
    licenseCheckField: null,
    label: "Offshort",
    permissionType: MAIN_LABEL.OFFSHORT,
    isExternal: true,
  },
];

export const allMenuItems = [dashboardItem, ...MintItems];

export const arrayToObjectArray = (arr) => {
  let ob = {};

  arr.forEach((a) => {
    ob = {
      ...ob,
      [a.sectionLabel]: {
        ...ob[a.sectionLabel],
        label: a.sectionLabel,
        items: [...(ob[a.sectionLabel]?.items || []), a],
      },
    };
  });

  return ob;
};

export const getFilteredByLicensePermissionSearchKey = (arr = []) => {
  return arr;
};
